import React, { Fragment, useEffect } from "react";
import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";
import "@/styles/pages/auth/request-otp.scss";
import { useDispatch } from "react-redux";
import { setCurrentForm, setMobileNumber, setToken } from "@/reducers/commonSlice";
import { Flex, Form, Input, Select, Space } from "antd";
import { requestOtp } from "@/services/accounts/requestOtp";
import { countryList } from "@/helpers/countryList";
import { keyFilterOption } from "@/helpers";

const { Option } = Select;

// Filter `option.label` match the user type `input`
// const filterOption = (input, option) => {
//   if (
//     (option?.key ?? "").toLowerCase().includes(input.toLowerCase()) ||
//     (option?.value ?? "").toLowerCase().includes(input.toLowerCase())
//   ) {
//     return true;
//   }
//   return false;
// };

const RequestOTP = ({ isOpen = false }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleSubmit = (value) => {
    const { number, countryCode = "+91" } = value;
    requestOtp({
      mobileNumber: countryCode + " " + number,
    })
      .then((response) => {
        console.log(response.data.totp);
        if (response.status == 206) {
          dispatch(setCurrentForm("signIn"));
        } else {
          dispatch(setMobileNumber(countryCode + " " + number));
          dispatch(setToken(response.data.token));
          dispatch(setCurrentForm("verifyOTP"));
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    if (!isOpen) {
      form.resetFields(); // Reset form fields when modal is closed
    }
  }, [isOpen, form]);

  return (
    <Fragment>
      <ModalComponent buttonLabel="Request OTP" isOpen={isOpen} className="onboarding-modal">
        <div className="request-otp-modal">
          <div className="header" style={{ height: "30px" }}>
            <img src="/assets/images/logo.png" height={"100%"} />
          </div>
          <div className="vector">
            <img src="/assets/images/illustration.svg" />
          </div>
          <div className="form">
            <Form
              name="requestOtp"
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={handleSubmit}
              form={form}
            >
              <Form.Item label="Phone Number*">
                <Space.Compact style={{ width: "100%" }}>
                  <Form.Item name={"countryCode"} noStyle>
                    <Select
                      virtual={false}
                      showSearch
                      placeholder="Select Country"
                      defaultValue={"+91"}
                      filterOption={keyFilterOption}
                    >
                      {countryList.map((country) => {
                        return (
                          <Option
                            key={country.name}
                            value={country.phoneCode}
                            label={country.phoneCode}
                          >
                            <Flex justify="start" align="center" gap={"5px"}>
                              <img src={country.flag} height={30} width={30} />{" "}
                              <span>{country.phoneCode}</span>
                            </Flex>
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="number"
                    noStyle
                    rules={[
                      {
                        required: true,
                        message: "Please enter a valid WhatsApp registered number.",
                        pattern: new RegExp(/^([0-9]{7,14})$/),
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      min={0}
                      minLength={7}
                      maxLength={14}
                      onWheel={(e) => e.currentTarget.blur()}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      style={{
                        width: "80%",
                      }}
                      placeholder="Enter your phone number"
                    />
                  </Form.Item>
                </Space.Compact>
              </Form.Item>
              <Form.Item>
                <div className="button">
                  <ButtonComponent
                    label="Send OTP"
                    varient="primary"
                    htmlType="submit"
                  ></ButtonComponent>
                </div>
              </Form.Item>
            </Form>
            <div className="signin">
              Already have an account?{" "}
              <span onClick={() => dispatch(setCurrentForm("signIn"))}>Sign In</span>
            </div>
          </div>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default RequestOTP;
